// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore, createHook, type Action } from '@atlassian/react-sweet-state';

interface State {
	isBlanketShown: boolean;
	isPolling: boolean;
}

const initialState: State = {
	isBlanketShown: false,
	isPolling: false,
};

const actions = {
	showBlanket:
		(): Action<State> =>
		({ setState }) =>
			setState({ isBlanketShown: true }),
	hideBlanket:
		(): Action<State> =>
		({ setState }) =>
			setState({ isBlanketShown: false, isPolling: false }),
	setIsPollingStatus:
		(isPolling: boolean): Action<State> =>
		({ setState }) =>
			setState({ isPolling }),
} as const;

type Actions = typeof actions;

const store = createStore<State, Actions>({
	name: 'loom-utils.loom-recorder-loading-blanket',
	initialState,
	actions,
});

export const useLoomRecorderLoadingBlanket = createHook(store);
